import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useCompany() {
  const [company, setCompany] = useState({ name: "BENEDETTA CARNI", address: "", vat: "" });
  useEffect(() => {
    const load = async () => {
      try {
        const r = await api.get("/companies/current");
        if (r.data && r.data.name) return setCompany({ ...r.data, logo: !!r.data.logo_path });
      } catch (e) { console.error("Azienda corrente non disponibile", e); }
      try {
        const r = await api.get("/settings");
        setCompany(r.data);
      } catch (e) { console.error("Impostazioni azienda non disponibili", e); }
    };
    load();
    window.addEventListener("company-updated", load);
    return () => window.removeEventListener("company-updated", load);
  }, []);
  return company;
}
